import { render, staticRenderFns } from "./ProductOrderDetails.vue?vue&type=template&id=f4ad6890&scoped=true"
import script from "./ProductOrderDetails.vue?vue&type=script&lang=js"
export * from "./ProductOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./ProductOrderDetails.vue?vue&type=style&index=0&id=f4ad6890&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ad6890",
  null
  
)

export default component.exports